"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    measureWidthInEms(text) {
        var _a, _b;
        try {
            // The value of pixelsPerEm is arbitrary, but should be large since
            // offsetWidth gets rounded to the nearest pixel. A bigger font
            // size produces more precise measurements.
            const pixelsPerEm = 100;
            const testSpan = document.createElement("span");
            testSpan.innerText = text;
            testSpan.style.position = "absolute";
            testSpan.style.visibility = "hidden";
            testSpan.style.left = "-9999px";
            testSpan.style.fontSize = `${pixelsPerEm}px`;
            testSpan.style.fontFamily = "MJXZERO, serif";
            (_a = document.body) === null || _a === void 0 ? void 0 : _a.appendChild(testSpan);
            const ems = testSpan.offsetWidth / pixelsPerEm;
            (_b = testSpan.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(testSpan);
            return ems;
        }
        catch (_c) {
            // We are probably not in an environment with a DOM; return a
            // reasonable default value
            return text.length;
        }
    },
};
